import axios, { AxiosInstance } from 'axios';
import { getVoiceFallbackClient } from './_shared';

// ── Dial Gate Simulation & Lead Intake ────────────────────────────────

export type GateCheckVerdict = {
  rule?: string | null;
  passed: boolean;
  reason?: string | null;
  detail?: string | null;
};

export type GateCheckRequest = {
  phone: string;
  channel?: 'call' | 'webrtc';
  contact_state?: string | null;
};

export type GateCheckResponse = {
  campaign_id: string;
  phone: string;
  allowed: boolean;
  failed_check?: number | null;
  checks: GateCheckVerdict[];
};

/** `POST /api/campaigns/{campaign_id}/gate/check` — Simulate the full Eligibility & Consent Gate for a {campaign, contact}. */
export async function checkDialGate(
  campaignId: string,
  payload: GateCheckRequest,
  axiosInstance?: AxiosInstance
): Promise<GateCheckResponse> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.post<GateCheckResponse>(`/api/campaigns/${campaignId}/gate/check`, payload);
  return response.data;
}

export type LeadIntakePayload = {
  phone: string;
  name?: string | null;
  address?: string | null;
  zip_code?: string | null;
  service?: string | null;
  notes?: string | null;
  source?: string | null;
};

export type LeadIntakeResponse = {
  lead_id: string;
  scheduled_campaign_id: string;
  status: string;
  estimated_call_within_seconds: number;
};

/** `POST /api/leads/intake/{token}` — Submit a lead via intake webhook token. */
export async function intakeLead(
  token: string,
  payload: LeadIntakePayload,
  axiosInstance?: AxiosInstance
): Promise<LeadIntakeResponse> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.post<LeadIntakeResponse>(`/api/leads/intake/${token}`, payload);
  return response.data;
}

